<content-loader [viewBox]="'0 0 940 260'" [backgroundColor]="'#f3f3f3'" [foregroundColor]="'#ecebeb'">
	<svg:rect x="0" y="0" rx="3" ry="3" width="627" height="24" />
	<svg:rect x="0" y="29" rx="3" ry="3" width="506" height="24" />
	<svg:rect x="0" y="77" rx="3" ry="3" width="590" height="16" />
	<svg:rect x="0" y="100" rx="3" ry="3" width="627" height="16" />
	<svg:rect x="0" y="123" rx="3" ry="3" width="480" height="16" />
	<svg:rect x="0" y="187" rx="3" ry="3" width="370" height="16" />
	<svg:circle cx="18" cy="239" r="18" />
	<svg:rect x="46" y="217" rx="3" ry="3" width="548" height="42" />
	<svg:rect x="683" y="3" rx="3" ry="3" width="135" height="14" />
	<svg:rect x="683" y="33" rx="3" ry="3" width="251" height="24" />
	<svg:rect x="683" y="90" rx="3" ry="3" width="135" height="14" />
	<svg:rect x="683" y="120" rx="3" ry="3" width="251" height="24" />
	<svg:rect x="683" y="177" rx="3" ry="3" width="135" height="14" />
	<svg:rect x="683" y="207" rx="3" ry="3" width="251" height="24" />
</content-loader>